import { useRef, useState } from "react";
import { FileUp, X } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errorMessage } from "@/lib/api";

const field = "h-9 min-w-0 flex-1 border border-line bg-ink px-2 text-xs outline-none focus:border-acid";
const isImage = (url) => /\.(png|jpe?g)(\?|$)/i.test(url);

const uploadPrintFile = async (file, onProgress) => {
  const { data } = await adminApi.post("/admin/gelato/uploads", { filename: file.name, size: file.size });
  for (let i = 0; i < data.chunks; i += 1) {
    const part = file.slice(i * data.chunk_size, (i + 1) * data.chunk_size);
    await adminApi.put(`/admin/gelato/uploads/${data.upload_id}/${i}`, part, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress(Math.round(((i + 1) / data.chunks) * 100));
  }
  return (await adminApi.post(`/admin/gelato/uploads/${data.upload_id}/complete`)).data;
};

export const PrintFileField = ({ label, value, onChange, testid }) => {
  const input = useRef(null);
  const [progress, setProgress] = useState(null);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setProgress(0);
    try {
      const res = await uploadPrintFile(file, setProgress);
      onChange(res.url);
      toast.success("File caricato", { description: `${res.filename} · ricordati di salvare` });
    } catch (err) {
      toast.error(errorMessage(err, "Caricamento non riuscito, riprova."));
    } finally {
      setProgress(null);
    }
  };

  return (
    <div data-testid={`${testid}-field`}>
      <p className="mb-1 font-mono text-[10px] uppercase tracking-[0.18em] text-smoke">{label}</p>
      <div className="flex items-center gap-2">
        {value && isImage(value) && <img src={value} alt="" className="h-9 w-9 shrink-0 border border-line bg-bone object-contain" data-testid={`${testid}-thumb`} />}
        <button type="button" onClick={() => input.current?.click()} disabled={progress !== null} data-testid={`${testid}-upload-button`}
          className="inline-flex h-9 shrink-0 items-center gap-1.5 border border-dashed border-bone/40 px-3 font-mono text-[10px] uppercase tracking-[0.15em] transition-colors hover:border-acid hover:text-acid disabled:opacity-60">
          <FileUp className="h-3.5 w-3.5" /> {progress !== null ? `${progress}%` : value ? "Sostituisci" : "Carica file"}
        </button>
        <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="oppure incolla un link https://…" data-testid={`${testid}-input`} className={field} />
        {value && (
          <button type="button" onClick={() => onChange("")} aria-label="Rimuovi file" data-testid={`${testid}-clear`} className="text-smoke transition-colors hover:text-red-300">
            <X className="h-4 w-4" />
          </button>
        )}
        <input ref={input} type="file" accept=".png,.jpg,.jpeg,.pdf" onChange={pick} className="hidden" data-testid={`${testid}-file`} />
      </div>
      {progress !== null && <div className="mt-1 h-0.5 bg-line"><div className="h-full bg-acid transition-[width] duration-200" style={{ width: `${progress}%` }} /></div>}
    </div>
  );
};
